// -----------------------------------------------------------------------------
// src/components/CreatorHeader.jsx  – desktop-left / mobile-right menu button
// -----------------------------------------------------------------------------
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';

import blitzLogo from './globalAssets/platty.png';
import routes from '../Config/routes';

/**
 * CreatorHeader
 * ─────────────
 * • Desktop →  menu button LEFT  | logo follows | rest of bar
 * • Mobile  →  logo LEFT         | spacer       | menu button RIGHT
 *
 * Accepts `menuIcon` (JSX) and optional `isDesktop` boolean (passed from parent).
 */
const CreatorHeader = ({ menuIcon, isDesktop: isDesktopProp }) => {
  const navigate = useNavigate();
  const theme    = useTheme();
  const upMd     = useMediaQuery(theme.breakpoints.up('md'));
  const isDesktop = typeof isDesktopProp === 'boolean' ? isDesktopProp : upMd;

  return (
    <AppBar position="fixed" id="CreatorHeader" sx={{ bgcolor: 'primary.main' }}>
      <Toolbar disableGutters sx={{ px: 2 }}>
        {isDesktop ? (
          <>
            {/* —— Menu button (left on desktop) —— */}
            {menuIcon}

            {/* —— Logo —— */}
            <IconButton
              color="inherit"
              aria-label="logo"
              onClick={() => navigate(routes.creatorConnectStart)}
              sx={{ p: 0, ml: 1 }}
            >
              <img src={blitzLogo} alt="Blitz Logo" style={{ height: 40 }} />
            </IconButton>
          </>
        ) : (
          <>
            {/* —— Logo (left on mobile) —— */}
            <IconButton
              color="inherit"
              aria-label="logo"
              onClick={() => navigate(routes.creatorConnectStart)}
              sx={{ p: 0 }}
            >
              <img src={blitzLogo} alt="Blitz Logo" style={{ height: 40 }} />
            </IconButton>

            {/* —— Spacer pushes everything that follows to the far right —— */}
            <Box sx={{ flexGrow: 1 }} />

            {/* —— Menu button (right on mobile) —— */}
            {menuIcon}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default CreatorHeader;